export default "__VITE_ASSET__51405031__"